// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_dismissAlertV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AlertDismissed"]);
}

var variablesConverter = {"dismissAlertInput":{},"__root":{"input":{"r":"dismissAlertInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"dismissAlertV5":{"u":"response_dismissAlertV5"}}};

var wrapResponseConverterMap = {
  response_dismissAlertV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"dismissAlertV5":{"u":"response_dismissAlertV5"}}};

var responseConverterMap = {
  response_dismissAlertV5: unwrap_response_dismissAlertV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function alertGroup_decode($$enum) {
  if ($$enum === "CONVERSATIONS" || $$enum === "MATCHES") {
    return $$enum;
  }
  
}

function alertGroup_fromString(str) {
  return alertGroup_decode(str);
}

function alertStatus_decode($$enum) {
  if ($$enum === "DISMISSED" || $$enum === "NEW") {
    return $$enum;
  }
  
}

function alertStatus_fromString(str) {
  return alertStatus_decode(str);
}

var Utils = {
  alertGroup_decode: alertGroup_decode,
  alertGroup_fromString: alertGroup_fromString,
  alertStatus_decode: alertStatus_decode,
  alertStatus_fromString: alertStatus_fromString
};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grouping",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AlertsDropdownDismissAlertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "dismissAlertV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "alert",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "AlertDismissed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlertsDropdownDismissAlertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "dismissAlertV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "alert",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AlertDismissed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1a3a963137172677b779ed8b6ed0ff90",
    "id": null,
    "metadata": {},
    "name": "AlertsDropdownDismissAlertMutation",
    "operationKind": "mutation",
    "text": "mutation AlertsDropdownDismissAlertMutation(\n  $input: DismissAlertInput!\n) {\n  dismissAlertV5(input: $input) {\n    __typename\n    ... on AlertDismissed {\n      alert {\n        __typename\n        grouping\n        status\n        nodeId\n      }\n    }\n  }\n}\n"
  }
};
})());

var wrap_response_dismissAlertV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_dismissAlertV5 = unwrap_response_dismissAlertV5;
exports.wrap_response_dismissAlertV5 = wrap_response_dismissAlertV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
